import usFlag from "../assets/images/flags/us.jpg";
import spain from "../assets/images/flags/vietnam.png";

const languages = {
  vi: {
    label: "Vietnamese",
    flag: spain,
  },
  en: {
    label: "English",
    flag: usFlag,
  },
};

export default languages;
